
import { mapGetters } from "vuex";
import ProfilesListV2 from "@/components/v2/profiles-list-v2.vue";
import { catalogRoutePrepareForServer } from "~/common/helpers.js";

export default {
  components: {
    ProfilesListV2,
  },

  props: {
    data: Array,

    maxCol: {
      type: Number,
      default: 4,
    },

    displayShowMore: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      lastPage: "profiles/getLastPage",
      countProfiles: "profiles/getCountProfiles",
      profileListViewMode: "catalog/getCatalogMode",
      profileMinCol: "catalog/getMinCol",
      page: "profiles/getCurrentPage",
      lastPageNumber: "profiles/getLastPageNumber",
      filters: "profiles/getFilters",
    }),

    numberOpenedProfiles() {
      return this.inDefaultView < this.data.length
        ? this.inDefaultView
        : this.data.length;
    },

    percentage() {
      return (this.data.length * 100) / this.countProfiles;
    },

    isPageQuery() {
      return this.$route.query.page;
    },

    isNewPage() {
      return this.filters.new;
    },

    prevRoute() {
      const r = { name: this.$route.name };
      if (this.page > 2) {
        r.query = { page: this.page - 1 };
      }
      return r;
    },
  },

  methods: {
    async showMoreProfiles() {
      this.loading = true;

      await this.$store.dispatch(
        "profiles/supplementProfilesAllShort",
        catalogRoutePrepareForServer(this.$route.path)
      );

      this.loading = false;
    },

    async getProfilesByPage(page) {
      this.loading = true;

      await this.$store.dispatch("profiles/retrieveProfilesAllShort", {
        page,
        route: catalogRoutePrepareForServer(this.$route.path),
      });

      this.loading = false;
    },

    loadMore() {
      if (this.lastPage || this.loading || this.isPageQuery) return;
      this.showMoreProfiles();
    },

    async nextPage() {
      if (this.lastPage || this.loading) return;
      this.$router.push({
        name: this.$route.name,
        query: { page: this.page + 1 },
      });
      // this.getProfilesByPage(this.page + 1);
      this.scrollToTop();
    },

    async previousPage() {
      if (this.loading) return;
      this.$router.push({
        name: this.$route.name,
        query: { page: this.page - 1 },
      });
      // this.getProfilesByPage(this.page - 1);
      this.scrollToTop();
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
